export enum HostEnv {
  Staging = 'staging',
  Staging4QA = 'staging4qa',
  Preview = 'preview',
  Production = 'production',
}

/**
 * 根据地址栏地址获取当前域名环境
 * @returns
 */
export function getHostEnvByLocation() {
  const { host } = window.location;
  const envFromHost = host && host.split('.')[0];
  for (const key in HostEnv) {
    const env = HostEnv[key as keyof typeof HostEnv];
    if (envFromHost === env) {
      return env;
    }
  }
  return HostEnv.Production;
}

export function getBaseUrlByLocation() {
  const { host } = window.location;
  if(host.indexOf('sgp-widget') > -1) {
    return  'https://global.developer.mi.com'
  }else {
    return 'http://devglobal.developer.mi.com'
  }
}

export const baseUrl = getBaseUrlByLocation()